<template>
  <div>
    <div class="page_title flex_between">
      <div class="align-center">
        <span style="margin-right: 16px">业绩结算详情</span>
        <div class="pre" v-if="status == 1">待结算</div>
        <div class="ed" v-if="status == 2">已结算</div>
        <div class="ing" v-if="status == 3">核算中</div>
      </div>
      <el-button type="primary" style="width: 92px" size="medium" @click="back"
        >返回</el-button
      >
    </div>
    <div style="padding: 20px">
      <div class="container">
        <div class="title">基本信息</div>
        <div class="info">
          <div style="display: flex">
            <div class="infoitem">
              <span class="gray">订单编号：</span>
              <span>{{ base_info.order_sn }}</span>
            </div>
            <div class="infoitem">
              <span class="gray">付款时间：</span>
              <span>{{ base_info.pay_time }}</span>
            </div>
          </div>
          <div style="display: flex; margin: 16px 0">
            <div class="infoitem">
              <span class="gray">用户姓名：</span>
              <span>{{ base_info.user_name }}</span>
              <span class="distributor" v-if="base_info.my_label_name">
                {{ base_info.my_label_name }}
              </span>
            </div>
            <div class="infoitem">
              <span class="gray"> 用户手机号：</span>
              <span>{{ base_info.phone }}</span>
            </div>
          </div>

          <div style="display: flex">
            <div class="infoitem" v-if="base_info.one_commission_user_name">
              <span class="gray">分销员：</span>
              <span style="margin-right: 12px">{{
                base_info.one_commission_user_name
              }}</span>
              <span>{{ base_info.one_commission_phone }}</span>
              <span class="distributor" v-if="base_info.star_label_name">
                {{ base_info.star_label_name }}
              </span>
            </div>

            <div class="infoitem" v-if="base_info.two_commission_user_name">
              <span class="gray">二级分销员：</span>
              <span style="margin-right: 12px">{{
                base_info.two_commission_user_name
              }}</span>
              <span>{{ base_info.two_commission_phone }}</span>
            </div>

            <div class="infoitem" v-if="base_info.recommender_name">
              <span class="gray">星推官信息：</span>
              <span>{{ base_info.recommender_name }}</span>
              <span>
                {{ base_info.recommender_phone }}
              </span>
            </div>

          </div>
        </div>
        <div class="title" style="margin-top: 40px">结算信息</div>
        <div>
          <span v-if="status == 1"
            >核算时间：{{ settlement_info.is_over_time | dateText }}</span
          >
          <span v-if="status == 2">
            <span> 结算时间：{{ settlement_info.is_settlement_time }} </span>
            <span v-if="settlement_info.admin_name" style="margin-left: 50px">
              结算人员：{{ settlement_info.admin_name }}
            </span>
          </span>
          <span v-if="status == 3"
            >预计核算时间：{{ settlement_info.es_settlement_time }}</span
          >
        </div>
        <div class="pricebox">
          <div class="price">
            <div class="priceitem">
              <div>
                <div style="font-weight: 700; margin-bottom: 6px">
                  {{ settlement_info.commission_user_name }}
                </div>
                <div class="gray" style="text-align: center; font-size: 12px">
                  {{
                    settlement_info.commission_type == 1
                      ? "星推官"
                      : "二级分销员"
                  }}
                </div>
              </div>
              <div class="num">{{ settlement_info.market_total_price }}</div>
            </div>
            <div class="priceitem" v-if="status == 1 || status == 3">
              <div class="gray">本月已结算佣金</div>
              <div class="num">
                {{ settlement_info.month_commission_money }}
              </div>
            </div>
            <div class="priceitem">
              <div class="gray">税前结算佣金</div>
              <div class="num">{{ settlement_info.commission_money }}</div>
            </div>
            <div class="priceitem" v-if="status == 2">
              <div class="gray">扣缴税额</div>
              <div class="num">{{ settlement_info.taxation_money }}</div>
            </div>
            <div class="priceitem" v-if="status == 2">
              <div class="gray">税后结算佣金</div>
              <div class="num">
                {{ settlement_info.after_commission_money }}
              </div>
            </div>
          </div>
          <el-button
            v-if="status == 1"
            type="primary"
            @click="Settlement"
            :disabled="
              module_id_array[0] ? !module_id_array.includes('1002') : false
            "
            >业绩结算</el-button
          >
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            :data="goods_info"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
          >
            <el-table-column label="商品名称" prop="goods_name">
            </el-table-column>
            <el-table-column label="数量" prop="sale_num"></el-table-column>
            <el-table-column
              label="实际金额"
              prop="sale_price"
            ></el-table-column>
            <el-table-column label="是否退款" prop="commission_phone">
              <template slot-scope="scope">
                <span v-if="scope.row.is_service == 1">是</span>
                <span v-if="scope.row.is_service == 0">否</span>
                <span class="refund" v-if="scope.row.tag">{{
                  scope.row.tag
                }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="退款金额"
              prop="refund_money"
            ></el-table-column>
            <el-table-column
              label="推广销售额"
              prop="extension_sale_price"
            ></el-table-column>
            <el-table-column label="提成比例">
              <template slot-scope="scope">
                <span v-if="scope.row.commission_one_proportion"
                  >一级{{ scope.row.commission_one_proportion }}%</span
                >
                <span
                  style="margin-left: 8px"
                  v-if="scope.row.commission_two_proportion"
                  >二级{{ scope.row.commission_two_proportion }}%</span
                >
              </template>
            </el-table-column>
            <el-table-column label="分销佣金" prop="commission_money">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import dayjs from "dayjs";
export default {
  data() {
    return {
      com_id: this.$route.query.com_id,
      base_info: {},
      settlement_info: {},
      goods_info: [],
      status: 1,
    };
  },
  filters: {
    dateText(val) {
      return val ? dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss") : "";
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array;
    },
  },
  methods: {
    getDetail() {
      let com_id = this.com_id;
      this.axios
        .post("platform/Distribution/getSettlementDetail", { com_id })
        .then((res) => {
          if (res.code == 0) {
            this.base_info = res.data.info.base_info;
            this.base_info.pay_time = dayjs
              .unix(this.base_info.pay_time)
              .format("YYYY-MM-DD HH:mm:ss");
            this.settlement_info = res.data.info.settlement_info;
            this.settlement_info.create_time = this.settlement_info.create_time
              ? dayjs
                  .unix(this.settlement_info.create_time)
                  .format("YYYY-MM-DD HH:mm:ss")
              : "";
            this.settlement_info.is_settlement_time = this.settlement_info
              .is_settlement_time
              ? dayjs
                  .unix(this.settlement_info.is_settlement_time)
                  .format("YYYY-MM-DD HH:mm:ss")
              : "";
            this.settlement_info.es_settlement_time = this.settlement_info
              .es_settlement_time
              ? dayjs
                  .unix(this.settlement_info.es_settlement_time)
                  .format("YYYY-MM-DD HH:mm:ss")
              : "";
            this.goods_info = res.data.info.goods_info;
            this.status = res.data.info.status;
          }
        });
    },
    Settlement() {
      let com_id = this.com_id;
      let loading = this.$loading({
        text: "操作正在执行中，请不要关闭或者退出当前页面",
      });
      this.$confirm("将该笔费用结算，并入到用户账户？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          this.axios
            .post("platform/Distribution/settlementStatus", { com_id })
            .then((res) => {
              if (res.code == 0) {
                this.$message.success("操作成功");
                this.getDetail();
              }
              loading.close();
            })
            .catch((err) => {
              loading.close();
            });
        })
        .catch(() => {
          loading.close();
        });
    },
    back() {
      history.back();
    },
  },
  created() {
    this.getDetail();
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  min-height: calc(100vh - 140px);
  text-align: left;
}
.title {
  font-size: 15px;
  font-weight: 700;
  margin-bottom: 10px;
}
.info {
  padding: 14px;
  border: solid 1px #cfcece;
  .infoitem {
    width: 360px;
    .infotitle {
      font-weight: 700;
    }
  }
}
.distributor {
  display: inline-block;
  color: #669961;
  border: 1px solid #669961;
  padding: 2px 3px;
  margin-left: 8px;
}
.refund {
  display: inline-block;
  color: #eb2929;
  border: 1px solid #eb2929;
  padding: 1px 2px;
  margin-left: 8px;
  font-size: 13px;
  border-radius: 5px;
}
.pricebox {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  box-sizing: border-box;
  border: solid 1px #cfcece;
  border-radius: 2px;
  margin: 12px 0;
  .price {
    display: flex;
    align-items: center;
    .priceitem {
      border-right: solid 1px #e1e3e9;
      display: flex;
      align-items: center;
      padding: 0 30px;
    }
    .priceitem:before {
      content: "";
    }
  }
  .gray {
    color: #747981;
  }
  .num {
    font-size: 22px;
    font-weight: 700;
    margin-left: 20px;
  }
}
.pre {
  padding: 0 10px;
  display: flex;
  align-items: center;
  height: 40px;
  color: #5086f6;
  background: #e0eaff;
  box-sizing: border-box;
}
.ed {
  padding: 0 10px;
  display: flex;
  align-items: center;
  height: 40px;
  color: #7dcf57;
  background: #ebf9e4;
  box-sizing: border-box;
}
.ing {
  padding: 0 10px;
  display: flex;
  align-items: center;
  height: 40px;
  color: #ffb65e;
  background: #fff0df;
  box-sizing: border-box;
}
.distributor {
  display: inline-block;
  color: #669961;
  border: 1px solid #669961;
  padding: 2px 3px;
  margin-left: 8px;
}
</style>